import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    title: {
        marginTop: '40px',
        marginBottom: theme.spacing(3)
    },
    buttonContainer: {
        width: '100%',
        display: "flex",
        padding: "1em"
    },
    button: {
        width: '75%',
        marginBottom: theme.spacing(1),
    },
}));


export default useStyles;